import React from 'react';
import Select from 'react-select';
import { Controller, Control } from 'react-hook-form';
import { IOption } from '../../../../types/options';
import styles from '../styled-select.module.scss';
import {
  styleBase,
  styleBold,
} from '../style';

interface SelectProps {
  name: string,
  control: Control<any>,
  options: IOption[],
  rules?: any,
  widthLabel?: string | null,
  inline?: boolean,
  placeholder?: string,
  isMulti?: boolean,
  label?: string | null,
  className?: string,
  isClearable?: boolean,
  isSearchable?: boolean,
  isDisabled?: boolean,
  defaultValue?: any,
  handleChange?: (val: any) => void,
  filterOption?: any,
  prop?: any,
}

const StyledSelect = ({
  name,
  control,
  rules,
  options,
  widthLabel = null,
  inline = false,
  placeholder = '',
  label = null,
  className,
  isClearable = false,
  isSearchable = false,
  defaultValue,
  handleChange,
  ...props
}: SelectProps) => {
  function getClassName() {
    let style;
    if (className === 'bold') style = styleBold;
    else style = styleBase;
    return style;
  }

  const getValue = (field: any) => {
    let value: any = null;
    if (props.isMulti && Array.isArray(field.value)) {
      value = options
        .filter((option: IOption) => field.value.includes(option.value));
    } else if (field.value) {
      value = options.find((option: IOption) => option.value === field.value);
    }
    return value;
  };

  const defaultFilterOption = (candidate: any, input: string) => {
    const term = String(input || '').trim().toLowerCase();
    if (!term) return true;

    const labelText = String(candidate?.label || '').toLowerCase();
    const value = String(candidate?.value || '').toLowerCase();
    const code = String(candidate?.data?.code || candidate?.code || '').toLowerCase();

    return labelText.includes(term) || value.includes(term) || code.includes(term);
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field,
      }) => (
        <div className={inline ? `${styles['container-select']} ${styles.inline}` : `${styles['container-select']}`}>
          {label && <label style={widthLabel ? { minWidth: widthLabel } : {}}>
            {label}
            {rules && (<sup>*</sup>)}
          </label>}
          <Select
            {...field}
            {...props}
            value={getValue(field)}
            options={options}
            filterOption={defaultFilterOption}
            onChange={(opt: IOption) => {
              field.onChange(props.isMulti ? opt : (opt?.value || null));
              if (handleChange) handleChange(opt);
            }}
            defaultValue={defaultValue}
            isClearable={isClearable}
            isSearchable={isSearchable}
            className={`${styles.select}`}
            placeholder={placeholder}
            styles={getClassName()}
          />
        </div>
      )}
    />
  );
};

export default StyledSelect;
